import { Box, Typography, Paper, Stack, SxProps, Theme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { RouteMap } from '@/routes/Routes';
import LockIcon from '@mui/icons-material/Lock';
import { FC } from 'react';
import { GoldButton } from '@/components/GoldButton';

interface UpgradePromptProps {
  featureName: string;
  description?: string;
  sx?: SxProps<Theme>;
}

const UpgradePrompt: FC<UpgradePromptProps> = ({
  featureName,
  description = `${featureName} is an upgraded feature`,
  sx,
}) => {
  const navigate = useNavigate();

  const handleUpgradeClick = () => {
    navigate(`${RouteMap.PLAN}#${RouteMap.PLAN_ANCHOR}`);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        backgroundColor: 'grey.50',
        border: '1px solid',
        borderColor: 'grey.200',
        borderRadius: 2,
        ...sx,
      }}
    >
      <Stack spacing={1.5}>
        {/* Description text on top */}
        <Typography variant="body2" color="text.secondary" fontWeight={600}>
          {description}
        </Typography>
        {/* Lock icon and Upgrade button on bottom row */}
        <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="space-between">
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: '50%',
              backgroundColor: 'primary.light',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <LockIcon sx={{ fontSize: 14, color: 'primary.main' }} />
          </Box>
          <GoldButton size="small" onClick={handleUpgradeClick} sx={{ px: 2 }}>
            Upgrade
          </GoldButton>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default UpgradePrompt;
